import { render, staticRenderFns } from "./MzColoring.vue?vue&type=template&id=503db120&scoped=true&"
import script from "./MzColoring.vue?vue&type=script&lang=js&"
export * from "./MzColoring.vue?vue&type=script&lang=js&"
import style0 from "./MzColoring.vue?vue&type=style&index=0&id=503db120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503db120",
  null
  
)

export default component.exports